var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTiktokLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "250px",
    height: "250px",
    viewBox: "0 0 250 250",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "tiktok-logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tiktok-logo",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tiktok-share-icon-black-seeklogo.com",
    transform: "translate(15.000000, 15.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.809524,0 L26.1904762,0 C11.7490476,0 0,11.7490476 0,26.1904762 L0,193.809524 C0,208.250952 11.7490476,220 26.1904762,220 L193.809524,220 C208.250952,220 220,208.250952 220,193.809524 L220,26.1904762 C220,11.7490476 208.250952,0 193.809524,0 M172.888571,95.977619 C171.687275,96.094351 170.481228,96.1555273 169.274286,96.1609524 C156.03574,96.1628005 143.688534,89.4899129 136.436667,78.4142857 L136.436667,138.84619 C136.436667,163.51412 116.439358,183.511429 91.7714286,183.511429 C67.1034987,183.511429 47.1061905,163.51412 47.1061905,138.84619 C47.1061905,114.178261 67.1034987,94.1809524 91.7714286,94.1809524 C92.7038095,94.1809524 93.6152381,94.2647619 94.5319048,94.322381 L94.5319048,116.332857 C93.6152381,116.222857 92.7142857,116.055238 91.7714286,116.055238 C79.1814402,116.055238 68.9752381,126.26144 68.9752381,138.851429 C68.9752381,151.441417 79.1814402,161.647619 91.7714286,161.647619 C104.36381,161.647619 115.484286,151.726667 115.484286,139.134286 L115.704286,36.4990476 L136.761429,36.4990476 C138.74704,55.3820395 153.972954,70.1313855 172.909524,71.5157143 L172.909524,95.977619",
    id: "Shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokLogo);
export default __webpack_public_path__ + "static/media/tiktok-logo.0a88529692fe30a61bb6729f5b1af5fd.svg";
export { ForwardRef as ReactComponent };